// extracted by mini-css-extract-plugin
export default {"presentModeContainer":"presentModeContainer__bdW6s"};